import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMetronidazoleGlyph from './svgs/MetronidazoleGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var metronidazoleGlyph = (props => useIcon(SvgMetronidazoleGlyph, null, props));

export { metronidazoleGlyph as default };
